/** @description Возвращает универсальные координаты для тач нажатия или клика
 * @param e {TMouseOrTouchEvent} объект события мыши или тач нажатия
 * @return {{ x: number, y: number }}
 */
import { TMouseOrTouchEvent } from '../types';
import { isTouchEvent } from './isTouchEvent';

export const getUniversalPosition = (e: TMouseOrTouchEvent) => {
  const event = (isTouchEvent(e) && e.changedTouches[0]) || (e as MouseEvent);

  return {
    x: event.clientX || 0,
    y: event.clientY || 0,
  };
};
